module.exports = __webpack_public_path__ + "img/bg.b09ae069.png";